// src/presets/aura/iconfield/index.ts
var iconfield_default = {
  icon: {
    color: "{form.field.icon.color}"
  }
};
export { iconfield_default as default };
